// extracted by mini-css-extract-plugin
export default {"container":"_b8820583","sectionDivider":"_9781fb0c"};